// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1320":"9900bfe3","4426":"9900bfe3","9168":"9199dddf"}[chunkId] + ".chunk.css";
};